import { render, staticRenderFns } from "./PluginDetails.vue?vue&type=template&id=25b7661f"
import script from "./PluginDetails.vue?vue&type=script&lang=js"
export * from "./PluginDetails.vue?vue&type=script&lang=js"
import style0 from "./PluginDetails.vue?vue&type=style&index=0&id=25b7661f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports